export default __webpack_public_path__ + "static/media/UNITY.4891abd2.png";